/**
 * The two ways a candidate can join.
 *
 * Both run through the same two-round selection. They differ in what happens
 * after: a direct internship goes straight onto live project work, while the
 * training route starts with structured teaching on the chosen course before
 * the same project deployment.
 */
export const PROGRAMME_ROUTES = [
  {
    value: 'internship',
    label: 'Internship',
    summary: 'Straight onto live project work',
    description:
      'For candidates who already have the fundamentals for their track. After selection you join a team and are given a real scope of work with a mentor reviewing it.',
    points: [
      'Two interview rounds',
      'Assigned to a live client or internal project',
      'Mentor review throughout',
      'Certificate on successful completion and project submission',
    ],
  },
  {
    value: 'training_internship',
    label: 'Training + Internship',
    summary: 'Structured training first, then live projects',
    description:
      'For candidates who want grounding in the course before working on live systems. Our expert team trains you on the selected course, then deploys you to a live project where you apply what you learned.',
    points: [
      'Two interview rounds',
      'Expert-led training on your chosen course',
      'Deployment to a live project afterwards',
      'Practical application of what you were taught',
      'Certificate on successful completion and project submission',
    ],
  },
];

export default PROGRAMME_ROUTES;
